import { render, staticRenderFns } from "./UserPianziListUpload.vue?vue&type=template&id=73a4ff5a&"
import script from "./UserPianziListUpload.vue?vue&type=script&lang=js&"
export * from "./UserPianziListUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports